import Swiper from 'swiper/bundle';

// Swiper's loop mode needs roughly 2x the largest `slidesPerView` in real
// slides to loop smoothly with centeredSlides — the widest breakpoint below
// uses 3.9, so we top up to 8 by cloning the real slides round-robin.
const MIN_SLIDES_FOR_LOOP = 8;

const related = {

    cloneItems(items, slides) {
        const fragment = document.createDocumentFragment();
        const cloneCount = MIN_SLIDES_FOR_LOOP - slides.length;

        for (let i = 0; i < cloneCount; i++) {
            const clone = slides[i % slides.length].cloneNode(true);
            fragment.appendChild(clone);
        }

        items.firstElementChild.appendChild(fragment);
    },

    updateSlideClasses(slides) {
        slides.forEach((slide, index) => {
            slide = slide.firstElementChild;
            slide.classList.remove('related__slide--top', 'related__slide--bottom');
            if (index % 2 === 0) {
                slide.classList.add('related__slide--top');
            } else {
                slide.classList.add('related__slide--bottom');
            }
        });
    },

	create(slider) {
		const items = slider.querySelector('.js-related-slider');
        let slides = Array.from(items.querySelectorAll('.swiper-slide'));

        if (slides.length < MIN_SLIDES_FOR_LOOP) {
            related.cloneItems(items, slides);
            slides = Array.from(items.querySelectorAll('.swiper-slide'));
        }

        new Swiper(items, {
            speed: 1000,
            slidesPerView: 2,
            spaceBetween: 0,
            centeredSlides: true,
            loop: true,
            slideToClickedSlide: true,
            simulateTouch: true,
            effect: 'slide',
            autoplay: {
                delay: 9000,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
            },
            breakpoints: {
                // when window width is >= 1190px
                1190: {
                    slidesPerView: 3.9,
                    spaceBetween: 0,
                },
            },
            navigation: {
				nextEl: ".js-related-next",
				prevEl: ".js-related-prev",
			},
		});

        related.updateSlideClasses(slides);
	},

	init() {
		const slider = document.querySelector('.js-related')

		if (slider) {
            related.create(slider);
		}
	},

};

export default function setRelated() {
    related.init();
}
